











































































import Vue, { PropType } from 'vue';

import {
  Booth,
  Item,
  Brand,
} from 'mostra';

interface DataType {
  footerButtonText: string;
  notFound: boolean;
}

export default Vue.extend({
  name: 'exhibitor-booth-edit',
  props: {
    isNew: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    booth: {
      type: Object as PropType<Booth>,
      required: true,
    },
    items: {
      type: Array as PropType<Item[]>,
      required: true,
    },
    brands: {
      type: Array as PropType<Brand[]>,
      required: true,
    },
    currentPage: {
      type: String as PropType<string>,
      required: true,
    },
    targetPageName: {
      type: String as PropType<string>,
      default: 'exhibitor-brand-edit',
    },
  },
  data(): DataType {
    return {
      footerButtonText: '',
      notFound: false,
    };
  },
  computed: {
    boothId(): string | null {
      return this.$route.query.id as string;
    },
    showTabLinks(): any[] {
      if (this.booth.data.template.id !== 3) {
        return this.tabLinks.filter((tabLink) => tabLink.text !== 'ピックアップ');
      }

      return this.tabLinks;
    },
    buttons(): any[] {
      return [{ text: '保存', onClick: this.toUpdateData, withValidation: true }];
    },
    headingTexts(): any[] {
      return [{ text: this.isNew ? 'ブースページ新規登録' : 'ブースページ編集' }];
    },
    tabLinks(): any[] {
      const q = this.$route.query;
      let ls: any[] = [];
      if (!this.isNew) {
        ls.push({
          value: 7,
          text: 'プレビュー',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'preview',
            },
          },
          validationId: 'g-booth-preview-form',
        });
      }
      ls = ls.concat([
        {
          value: 0,
          text: '基本設定',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'settings',
            },
          },
          validationId: 'g-booth-setting-form',
        },
        {
          value: 1,
          text: '商品選択',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'items',
            },
          },
          validationId: 'g-booth-item-form',
        },
        {
          value: 2,
          text: 'テンプレート選択',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'template',
            },
          },
          validationId: 'g-booth-template-form',
        },
        {
          value: 3,
          text: 'デザイン設定',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'design',
            },
          },
          validationId: 'g-booth-design-form',
        },
        {
          value: 4,
          text: 'ピックアップ',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'pickup',
            },
          },
          validationId: 'g-booth-pickup-form',
        },
        {
          value: 5,
          text: 'ストーリー',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'story',
            },
          },
          validationId: 'g-booth-story-form',
        },
        {
          value: 6,
          text: '商品掲載',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'lineup',
            },
          },
          validationId: 'g-booth-lineup-form',
        },
      ]);
      return ls;
    },
  },
  methods: {
    async toUpdateData() {
      this.$emit('toUpdateData');
    },
    onSelectTemplate() {
      this.$router.push({
        name: this.targetPageName,
        query: {
          ...this.$route.query,
          page: 'design',
          id: this.boothId,
        },
      });
    },
    onClickTemplateReset() {
      if (!this.booth) return;
      this.booth.data.template.id = null;
      this.$router.push({
        name: this.targetPageName,
        query: {
          ...this.$route.query,
          page: 'template',
          id: this.boothId,
        },
      });
    },
  },
});
